import { useCallback } from 'react';
import { getUserFromLocalStorage } from '../../hooks/user/useUser';

import { utils } from '../../utils/utils';

const useAuthorize = () => {
    return useCallback((roles) => {
        const dataUser = getUserFromLocalStorage();

        if(!dataUser)
            return null;

        const { user } = dataUser;

        if(!user || !user.roles)
            return false;

        return utils
            .selectMany(user.roles, "permissions")
            .map(permission => permission.code)
            .some(code => roles.includes(code));
    }, [])
}

export default useAuthorize;